import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

export default function DeleteButton(props) {
    const disabled = props.disabled;
    const onSubmit = props.onSubmit;
    const deleting = props.deleting;
    const { t } = useTranslation();

    return (
        <Button
            variant="contained"
            name={props.name ? props.name : 'delete'}
            onClick={onSubmit}
            disabled={disabled}
            startIcon={deleting ? <CircularProgress size={'1rem'} /> : <DeleteIcon />}>
            {t('buttons.remove')}
        </Button>
    );
}
